import DashboardPage from "../../../../components/DashboardPage";
import BottomView from "./bottom-view";
import { metadata } from "./meta";
import UpperArea from "./top-view";
import Modal from "../../../../library/modal";
import AttentionBox from "../../../../library/attention-box";
import { NotificationsWrapper } from "./styled";
import { useAccountNotifications } from "../../../../hooks/useAccountNotifications";
import { useState } from "react";
import NewWorkspaceModal from "../../../../components/NewWorkspaceModal";

const Content = () => {
  const [isWorkspaceModalOpen, setIsWorkspaceModalOpen] = useState(false);
  const openWorkspaceModal = () => setIsWorkspaceModalOpen(true);
  const closeWorkspaceModal = () => setIsWorkspaceModalOpen(false);

  const notifications = useAccountNotifications({
    openModal: openWorkspaceModal,
  });

  const renderNotifications = () => {
    if (!notifications || notifications.length === 0) {
      return null;
    }

    return (
      <NotificationsWrapper>
        {notifications.map((notification) => (
          <AttentionBox
            key={notification.id}
            type={notification.type}
            icon={notification.icon}
            title={notification.title}
            text={notification.text}
            buttonText={notification?.buttonText}
            onClick={notification?.onClick}
          />
        ))}
      </NotificationsWrapper>
    );
  };

  return (
    <>
      <DashboardPage
        notification={renderNotifications()}
        meta={metadata}
        layout="stacked"
      >
        <UpperArea />
        <BottomView />
      </DashboardPage>
      <Modal
        onClose={closeWorkspaceModal}
        open={isWorkspaceModalOpen}
        title="Nytt arbeidsmiljø"
        size={500}
      >
        <NewWorkspaceModal onClose={closeWorkspaceModal} />
      </Modal>
    </>
  );
};

export default Content;
